module.exports = __webpack_public_path__ + "static/media/66960015-HaU0wSgs.0344605a.JPG";